import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type CollectionStatsVariables = Types.Exact<{
  contractSlug: Types.Scalars['citext'];
  indexedStates: Array<Types.Scalars['Boolean']> | Types.Scalars['Boolean'];
}>;


export type CollectionStats = { collection: Array<{ owners: Array<{ owner: Types.Maybe<Pick<Types.User, 'publicKey' | 'profileImageUrl'>> }>, ownersCount: { aggregate: Types.Maybe<Pick<Types.Artwork_Aggregate_Fields, 'count'>> }, artworks: { aggregate: Types.Maybe<Pick<Types.Artwork_Aggregate_Fields, 'count'>> }, lastPrivateSales: { aggregate: Types.Maybe<{ sum: Types.Maybe<Pick<Types.Private_Sale_Sum_Fields, 'saleAmountInETH'>> }> }, lastAuctions: { aggregate: Types.Maybe<{ sum: Types.Maybe<Pick<Types.Auction_Sum_Fields, 'highestBidAmount'>> }> }, activeAuctions: { aggregate: Types.Maybe<{ min: Types.Maybe<Pick<Types.Auction_Min_Fields, 'highestBidAmount' | 'reservePriceInETH'>> }> }, lastBuyNows: { aggregate: Types.Maybe<{ sum: Types.Maybe<Pick<Types.Buy_Now_Sum_Fields, 'amountInETH'>> }> }, activeBuyNows: { aggregate: Types.Maybe<{ min: Types.Maybe<Pick<Types.Buy_Now_Min_Fields, 'amountInETH'>> }> }, lastAcceptedOffers: { aggregate: Types.Maybe<{ sum: Types.Maybe<Pick<Types.Offer_Sum_Fields, 'amountInETH'>> }> } }> };



export const CollectionStatsDocument = /*#__PURE__*/ `
    query CollectionStats($contractSlug: citext!, $indexedStates: [Boolean!]!) @cached(ttl: 30) {
  collection(where: {slug: {_eq: $contractSlug}}) {
    owners: artworks(
      limit: 4
      distinct_on: ownerPublicKey
      where: {isIndexed: {_in: $indexedStates}, status: {_eq: "MINTED"}, deletedAt: {_is_null: true}}
    ) {
      owner {
        publicKey
        profileImageUrl
      }
    }
    ownersCount: artworks_aggregate(
      distinct_on: ownerPublicKey
      where: {isIndexed: {_in: $indexedStates}, status: {_eq: "MINTED"}, deletedAt: {_is_null: true}}
    ) {
      aggregate {
        count
      }
    }
    artworks: artworks_aggregate(
      where: {isIndexed: {_in: $indexedStates}, status: {_eq: "MINTED"}, deletedAt: {_is_null: true}}
    ) {
      aggregate {
        count
      }
    }
    lastPrivateSales: privateSales_aggregate(where: {soldAt: {_is_null: false}}) {
      aggregate {
        sum {
          saleAmountInETH
        }
      }
    }
    lastAuctions: auctions_aggregate(where: {status: {_in: ["FINALIZED", "ENDED"]}}) {
      aggregate {
        sum {
          highestBidAmount
        }
      }
    }
    activeAuctions: auctions_aggregate(
      where: {endsAt: {_is_null: true}, status: {_eq: "OPEN"}}
    ) {
      aggregate {
        min {
          highestBidAmount
          reservePriceInETH
        }
      }
    }
    lastBuyNows: buyNows_aggregate(where: {status: {_eq: ACCEPTED}}) {
      aggregate {
        sum {
          amountInETH
        }
      }
    }
    activeBuyNows: buyNows_aggregate(
      where: {acceptedAt: {_is_null: true}, canceledAt: {_is_null: true}, invalidatedAt: {_is_null: true}}
    ) {
      aggregate {
        min {
          amountInETH
        }
      }
    }
    lastAcceptedOffers: offers_aggregate(where: {acceptedAt: {_is_null: false}}) {
      aggregate {
        sum {
          amountInETH
        }
      }
    }
  }
}
    `;

export const useCollectionStats = <
      TData = CollectionStats,
      TError = ClientError
    >(
      variables: CollectionStatsVariables,
      options?: Omit<UseQueryOptions<CollectionStats, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CollectionStats, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CollectionStats, TError, TData>(
      {
    queryKey: ['CollectionStats', variables],
    queryFn: hasuraFetcher<CollectionStats, CollectionStatsVariables>(CollectionStatsDocument, variables),
    ...options
  }
    )};

useCollectionStats.getKey = (variables: CollectionStatsVariables) => ['CollectionStats', variables];

export const useInfiniteCollectionStats = <
      TData = InfiniteData<CollectionStats>,
      TError = ClientError
    >(
      variables: CollectionStatsVariables,
      options: Omit<UseInfiniteQueryOptions<CollectionStats, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CollectionStats, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CollectionStats, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CollectionStats.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<CollectionStats, CollectionStatsVariables>(CollectionStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCollectionStats.getKey = (variables: CollectionStatsVariables) => ['CollectionStats.infinite', variables];


useCollectionStats.fetcher = (variables: CollectionStatsVariables, options?: RequestInit['headers']) => hasuraFetcher<CollectionStats, CollectionStatsVariables>(CollectionStatsDocument, variables, options);
